import index from './sidebar'

export default index